import { Box, Typography, useTheme } from '@mui/material';
import React, { useMemo } from 'react';

export const Footer = () => {
  const theme = useTheme();

  const year = useMemo(() => new Date().getFullYear(), []);

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: theme.palette.primary.main,
        bottom: 0,
        color: theme.palette.primary.contrastText,
        display: 'flex',
        height: theme.spacing(8),
        justifyContent: 'center',
        padding: '12px',
        position: 'fixed',
        width: '100%',
        zIndex: '10',
      }}
    >
      <Typography variant="body2">
        YourSteps Health © {year}. All rights reserved.
      </Typography>
    </Box>
  );
};
